const DISPATCH_EVENTS = {
  '.TeamDispatched': 'dispatched',
  '.TeamDispatchCancelled': 'cancelled',
  '.TeamDispatchCompleted': 'completed',
  '.TeamPositionReported': 'position',
}

export default {
  data() {
    return {
      dispatchEventsChannelName: null,
      dispatchEventsListeners: {},
    }
  },

  methods: {
    watchDispatchEvents() {
      if (typeof window.Echo === 'undefined') return
      if (Object.keys(this.dispatchEventsListeners).length) return

      const node = this.$store.state.selected_node
      if (!node || !node.id) return

      this.dispatchEventsChannelName = `node.${node.id}`
      const channel = window.Echo.private(this.dispatchEventsChannelName)

      Object.keys(DISPATCH_EVENTS).forEach(nome => {
        const kind = DISPATCH_EVENTS[nome]
        const listener = payload => this.onDispatchEventReceived(kind, payload)

        this.dispatchEventsListeners[nome] = listener
        channel.listen(nome, listener)
      })
    },

    unwatchDispatchEvents() {
      if (typeof window.Echo === 'undefined' || !this.dispatchEventsChannelName) return

      // stopListening e nao leave(): o canal do no e compartilhado com as
      // posicoes, as solicitacoes de equipe e o feed de ocorrencias.
      const channel = window.Echo.private(this.dispatchEventsChannelName)

      Object.keys(this.dispatchEventsListeners).forEach(nome => {
        channel.stopListening(nome, this.dispatchEventsListeners[nome])
      })

      this.dispatchEventsChannelName = null
      this.dispatchEventsListeners = {}
    },

    onDispatchEventReceived(kind, payload) {
      if (!payload) return
      if (kind !== 'position' && !payload.dispatch_id) return
      if (kind === 'position' && !payload.position_id) return
      if (typeof this.onDispatchEvent === 'function') this.onDispatchEvent(kind, payload)
    },
  },

  beforeDestroy() {
    this.unwatchDispatchEvents()
  },
}
